import React from 'react';
import './Header.css';

const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="header-content">
        <h1>スマート税金計算</h1>
        <p>給与明細をアップロードして所得税やふるさと納税を自動計算</p>
      </div>
    </header>
  );
};

export default Header;
